import { render, staticRenderFns } from "./bannerSwiper.vue?vue&type=template&id=32e357d8&scoped=true&"
import script from "./bannerSwiper.vue?vue&type=script&lang=js&"
export * from "./bannerSwiper.vue?vue&type=script&lang=js&"
import style0 from "./bannerSwiper.vue?vue&type=style&index=0&id=32e357d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e357d8",
  null
  
)

export default component.exports